export enum MessageAccessType {
  Everybody = 'Everybody',
  Internal = 'Internal',
  Me = 'Me',
}
